<template lang="pug">
  form(role='form')
    payout-form-group(:label="$t('Номер счета PayTM')"
      class="form-group__label_align_start"
      :required="model.isRequiredAttribute('destinationAccount')" :has-errors="model.errors.has('destinationAccount')")
      filtered-input-wrapper(v-model='model.values.destinationAccount')
      payout-input-hint-block(v-slot:hints :hint="$t('paytm.destinationHint')")
      error-message-block(v-slot:errors attribute='destinationAccount|*' :errors='model.errors')

    //payout-form-group(:label="$t('Label')" :required="model.isRequiredAttribute('label')" :has-errors="model.errors.has('label')")
      input.form-control(type='text' name='label' v-model='model.values.label')
      //payout-input-hint-block(slot='hints' :hint="$t('paytm.destinationHint')")
      error-message-block(slot='errors' attribute='label' :errors='model.errors')

    payout-textfield-input-group(:model='model' attribute='description' :label="$t('Назначение платежа')")

    payout-input-amount-form-group(:model='model')
    payout-estimated-destination-amount-form-group(:model='model')

    payout-destination-currency-conversion-notice-form-group(:model='model')
    payout-evaluate-fee-form-group(:model='model')
    //payout-toggable-hint-panel-form-group(:heading="$t('Лимиты')" :link-text="$t('Информация о лимитах')")
      | {{ model.options.limitsText }}
      br
      |             {{ model.options.limitsText2 }}
    payout-toggable-hint-panel-form-group(:heading="$t('Лимиты')" :link-text="$t('Информация о лимитах')")
      div
        i18n(path="limits_min" tag="div")
          template(v-slot:min) 2000 INR
        i18n(path="limits_max" tag="div")
          template(v-slot:max) 30000 INR
        i18n(path="limits_convertation_simple" tag="div")
          template(v-slot:currency) INR


    payout-form-notification-block(:model='model')
    hr
    payout-group-verification-type(:model='model')

</template>

<script lang="ts">
import {Component} from "vue-property-decorator";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import {PayTMPayoutModel} from "@/components/forms/payout/forms/paytm";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import PayoutDestinationCurrencyConversionNoticeFormGroup
  from "@/components/forms/payout/crypto/PayoutDestinationCurrencyConversionNoticeFormGroup.vue";




@Component({
  name: "PayTMPaymentForm",
  components: {
    PayoutDestinationCurrencyConversionNoticeFormGroup,
    FilteredInputWrapper,
    PayoutFormNotificationBlock,
    PayoutEvaluateFeeFormGroup,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutInputAmountFormGroup,
    PayoutGroupVerificationType,
    PayoutToggableHintPanelFormGroup,
    PayoutTextfieldInputGroup,
    ErrorMessageBlock,
    PayoutInputHintBlock,
    PayoutFormGroup
  }
})
export default class PayTMPaymentForm extends AbstractPayoutForm {

  model: PayTMPayoutModel = new PayTMPayoutModel();



}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Номер счета PayTM": "PayTM account number",
    "Назначение платежа": "Description",
    "paytm": {
      "destinationHint": "Account number: digits."
    },
    "limits_min": "Minimum one-time payment: {min}.",
    "limits_max": "Maximum one-time payment: {max} or equivalent in the selected currency.",
    "limits_convertation": "In case of sending payments not from {currency} accounts, the amount will be automatically converted to {currency} at the current rate.",
    "limits_convertation_simple": "The amount will be automatically converted to {currency} at the current rate.",
    "Лимиты": "Limits",
    "Информация о лимитах": "Limits information"
  },
  "ru": {
    "limits_min": "Минимальный разовый платеж: {min}.",
    "limits_max": "Максимальный разовый платеж: {max} или эквивалент в выбранной валюте.",
    "limits_convertation": "В случае отправки платежей не с {currency} счетов Capitalist сумма будет автоматически сконвертирована в {currency} по текущему курсу.",
    "limits_convertation_simple": "Сумма будет автоматически сконвертирована в {currency} по текущему курсу.",
    "paytm": {
      "destinationHint": "Номер счета: цифры."
    }
  }
}
</i18n>
